<template>

    <div>
    <comment-nav
        :userInfo="userInfo"
        :content_id="content_id"
        :content_kind="content_kind"
    />
    </div>

</template>

<script>

import CommentNav from "@/components/CommentNav/comment.vue"
export default {
name: "comment",
components:{
    CommentNav,
},
data() {
    return {
        content_id:'974854',//内容的id beta 1255699 1256710 1257142
        content_kind:'express',//评论种类 固定
        userInfo:{},
    };
},
created() {
    //dev 843508
    //beta 2786315
    //&hot_page=1&order_by_field=hot
},

methods: {


}
};
</script>
